import { OFFICE_SECTIONS } from './office-sections';

/** One step in a page's breadcrumb trail: a link when `to` is set, plain text (a nav group) when not. */
export interface Crumb {
  label: string;
  to?: string;
}

function findSection(slug: string) {
  const section = OFFICE_SECTIONS.find((candidate) => candidate.slug === slug);
  if (!section) throw new Error(`Unknown office section: ${slug}`);
  return section;
}

/** The crumbs above an office section's own page: just its nav group, which isn't a page and so isn't a link. */
export function sectionTrail(slug: string): Crumb[] {
  return [{ label: findSection(slug).group }];
}

/**
 * The crumbs above a page inside an office section (a record, or a page below a tab): the group,
 * the section as a link, then `path` — the steps in between, such as the tab the record lives on.
 */
export function withinSection(slug: string, ...path: Crumb[]): Crumb[] {
  const section = findSection(slug);
  return [{ label: section.group }, { label: section.label, to: `/${section.slug}` }, ...path];
}
